import { useEffect } from 'react';

const SCROLLBAR_STYLE_ID = 'labelContainer-scrollbar-styles';

const scrollbarCSS = `
  .labelContainer {
    scrollbar-width: thin;
    scrollbar-color: #3d3649 #1a1720;
  }
  .labelContainer::-webkit-scrollbar {
    width: 3px !important;
    height: 3px !important;
  }
  .labelContainer::-webkit-scrollbar-track {
    background: #1a1720 !important;
    border-radius: 999px !important;
  }
  .labelContainer::-webkit-scrollbar-thumb {
    background: #3d3649 !important;
    border-radius: 999px !important;
    min-height: 40px;
  }
  .labelContainer::-webkit-scrollbar-thumb:hover {
    background: #524963 !important;
  }
  .labelContainer::-webkit-scrollbar-corner {
    background: transparent !important;
  }
  [data-focused="true"] {
    box-shadow: 0 0 0 3px #DEBB68, inset 0 0 8px rgba(222, 187, 104, 0.3) !important;
    transition: box-shadow 0.2s ease-in-out;
  }
`;

export default function useScrollbarStyles() {
  useEffect(() => {
    if (!document.getElementById(SCROLLBAR_STYLE_ID)) {
      const styleEl = document.createElement('style');
      styleEl.id = SCROLLBAR_STYLE_ID;
      styleEl.textContent = scrollbarCSS;
      document.head.appendChild(styleEl);
    }
    return () => {
      document.getElementById(SCROLLBAR_STYLE_ID)?.remove();
    };
  }, []);
}
